import React, { useEffect, useState } from 'react'
import lpllogo from '../../assets/images/logo.png';
import suburbunlogo from '../../assets/images/suburban.webp';
import '../../assets/stylesheet/layout.scss';
import '../../assets/stylesheet/feedback.scss';
import 'font-awesome/css/font-awesome.min.css';
import GetUserData from '../../utilities/getUserDetails';
import Form from 'react-bootstrap/Form';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { ShowToastUtil } from '../../utilities/showToastUtil';
import { Button } from 'react-bootstrap';
// import SelectLanguage from './selectlanguage';

function LikeServices() {
    const location = useLocation();
    const navigate = useNavigate();
    const query = queryString.parse(location.search);
    const decodedRating = decodeURIComponent(query.selectedRating);
    const decodedLang = decodeURIComponent(query.lang);
    const selectedProject = decodeURIComponent(query.project)
    const [userRating, setUserRating] = useState();
    const [selectedOptions, setSelectedOptions] = useState('');
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const [projectFilter, setProjectFilter] = useState('');
    const [userInfo, setUserInfo] = useState(GetUserData());

    useEffect(() => {
        setUserRating(decodedRating);
        setSelectedLanguage(decodedLang);
    }, [decodedRating, decodedLang]);
    useEffect(() => {
            setProjectFilter(selectedProject);
     }, [selectedProject]);
    const handleCheckboxChange = (event) => {
        const optionId = event.target.id;
        if (optionId) {
            setSelectedOptions(optionId);
            const checkedOption = encodeURIComponent(optionId);
            navigate(`/labNumber?selectedOption=${checkedOption}&lang=${selectedLanguage}&project=${projectFilter}`);
        } else {
            ShowToastUtil('Please select any option', 'warning');
        }
    };
    var metrics = [];
    if (selectedProject == 1) {
        if (selectedLanguage == 'eng') {
            metrics = [
                { label: 'Centre ambience & hygiene', key: 'SCHygiene' },
                { label: 'Empathetic behaviour of the staff during entire process', key: 'SCEmpathetic' },
                { label: 'Skill of technician while performing the medical procedure', key: 'SCSkill' },
                { label: 'Staff knowledge & attention during registration/billing', key: 'SCStaff' },
                { label: 'Overall time taken to complete the entire process', key: 'SCOverall' },
            ]
        }
        else if (selectedLanguage == 'hin') {
            metrics = [
                { label: 'सेंटर का माहौल और साफ-सुथरापन', key: 'SCHygiene' },
                { label: 'रजिस्ट्रेशन/ बिलिंग के दौरान कर्मचारीयों का ज्ञान और सावधानी', key: 'SCEmpathetic' },
                { label: 'चिकित्सीय प्रक्रिया करते वक्त टेक्निशियन का कौशल्य', key: 'SCSkill' },
                { label: 'संपूर्ण प्रक्रिया के दौरान कर्मचारीयों का समानुभूति रखने वाला वर्तन', key: 'SCStaff' },
                { label: 'संपूर्ण प्रक्रिया पूरी करने के लिए लिया गया कुलमिलाकर समय', key: 'SCOverall' },
            ]
        }
    }
    else if (selectedProject == 4) {
        if (userRating == 'promotor') {
            if (selectedLanguage == 'eng') {
                metrics =
                    [
                        { label: 'Excellent service', key: 'FTRExcellent' },
                        { label: 'Great behaviour', key: 'FTRBehaviour' },
                        { label: 'Expert knowledge', key: 'FTRKnowledge' },
                        { label: 'Fast query resolution', key: 'FTRFast' },
                        { label: 'Quality of resolution', key: 'FTRQuality' }]
            }
            else {
                metrics = [
                    { label: 'बेहतरीन सेवा', key: 'FTRExcellent' },
                    { label: 'बेहतरीन वर्तन', key: 'FTRBehaviour' },
                    { label: 'एक्सपर्ट का ज्ञान', key: 'FTRKnowledge' },
                    { label: 'प्रश्न का तेज समाधान', key: 'FTRFast' },
                    { label: 'समाधान की क्वालिटी', key: 'FTRQuality' }]
            }
        } else {
            if (selectedLanguage == 'eng') {
                metrics =
                    [
                        { label: 'Long wait time', key: 'FTRTime' },
                        { label: 'Advisor behaviour', key: 'FTRAdvisor' },
                        { label: 'Query resolution time', key: 'FTRResolutionTime' },
                        { label: 'Quality of resolution', key: 'FTRQuality' }
                    ]
            }
            else {
                metrics =
                    [
                        { label: 'इंतजार का लंबा समय', key: 'FTRTime' },
                        { label: 'सलाहगार का वर्तन', key: 'FTRAdvisor' },
                        { label: 'प्रश्न के समाधान का समय', key: 'FTRResolutionTime' },
                        { label: 'समाधान की क्वालिटी', key: 'FTRQuality' }
                    ]
            }
        }
    }
    else if (selectedProject == 5) {
        if (userRating == 'promotor') {
            if (selectedLanguage == 'eng') {
                metrics = [
                    { label: 'Excellent service', key: 'FTNRExcellent' },
                    { label: 'Speedy issue resolution', key: 'FTNRSpeedy' },
                    { label: 'Great behaviour', key: 'FTNRGreat' },
                    { label: 'Quality of resolution', key: 'FTNRQuality' }]
            }
            else {
                metrics = [
                    { label: 'बेहतरीन सेवा', key: 'FTNRExcellent' },
                    { label: 'समस्या का तेज समाधान', key: 'FTNRSpeedy' },
                    { label: 'बेहतरीन वर्तन', key: 'FTNRGreat' },
                    { label: 'समाधान की क्वालिटी', key: 'FTNRQuality' }]
            }
        }
        else {
            if (selectedLanguage == 'eng') {
                metrics = [
                    { label: 'Advisor knowledge', key: 'FTNRAdvisorKnowledge' },
                    { label: 'Advisor behaviour', key: 'FTNRBehaviour' },
                    { label: 'Issue resolution time', key: 'FTNRIssue' },
                    { label: 'No/Limited update received about the issue', key: 'FTNRNoLimited' },
                    { label: 'Limited self-service options', key: 'FTNRSelfService' },
                    { label: 'Quality of resolution', key: 'FTNRQuality' }
                ]
            }
            else {
                metrics = [
                    { label: 'सेल्फ-सर्विस के सीमित विकल्प', key: 'FTNRAdvisorKnowledge' },
                    { label: 'समस्या के बारे में कोई अपडेट प्राप्त नही हुए/ कम अपडेट प्राप्त हुए', key: 'FTNRBehaviour' },
                    { label: 'समस्या के समाधान का समय', key: 'FTNRIssue' },
                    { label: 'समाधान की क्वालिटी', key: 'FTNRNoLimited' },
                    { label: 'सलाहगार का वर्तन', key: 'FTNRSelfService' },
                    { label: 'सलाहगार का ज्ञान', key: 'FTNRQuality' },
                ]
            }
        }
    }
    var secondaryQuestion = '';
    if (selectedProject == 1) {
        if (selectedLanguage == 'eng') {
            secondaryQuestion = userRating == 'promotor' ? 'What did you like the most?' : 'What as per you requires our immediate attention for improvement ?';
        }
        else if (selectedLanguage == 'hin') {
            secondaryQuestion = userRating == 'promotor' ? 'आपको क्या सबसे ज्यादा पसंद आया?' : 'आपके अनुसार कौनसी बातों में सुधार के लिए हमें तुरंत ध्यान देने की आवश्यकता हैं ?';
        }
    }
    else if (selectedProject == 4) {
        if (selectedLanguage == 'eng') {
            secondaryQuestion = userRating == 'promotor' ? 'What did you like the most?' : 'In your opinion, what requires our immediate attention for improvement?';
        }
        else {
            secondaryQuestion = userRating == 'promotor' ? 'आपको क्या सबसे ज्यादा पसंद आया?' : 'कॉन्टैक्ट सेंटर के साथ आपके अनुभव के आधार पर, क्या आप अपने परिवार/ दोस्तों को डॉ. लाल पॅथलैब्स की सिफारीश करेंगे?';
        }
    }
    else if (selectedProject == 5) {
        if (selectedLanguage == 'eng') {
            secondaryQuestion = userRating == 'promotor' ? 'What went well?' : 'What did not work?';
        }
        else {
            secondaryQuestion = userRating == 'promotor' ? 'कौनसी बातें अच्छी हुई?' : 'कौनसा काम हुआ नही?';
        }
    }
    const isSuburban = userInfo?.Company?.toLowerCase() === "sdpl";
    return (
        <>
            <div className='container-fluid feedback-form'>
                <div className='row'>
                    <div className='col-14 col-sm-14 col-md-9 col-lg-9 col-xl-9 '>
                        <div className='logo-section'>
                            {isSuburban ? (
                                <img alt="Suburban Diagnostics India Pvt Limited" className='f-logo' src={suburbunlogo} />
                            ) : (
                                <img alt="Dr Lal Path Labs" className='f-logo' src={lpllogo} />
                            )}

                        </div>
                    </div>
                    <div className='col-14 col-sm-14 col-md-8 col-lg-8 col-xl-8'>
                        <div className='form-section'>
                            <div className='row'>
                                <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center'>
                                    <h5 className='feedback-title mb-5'>
                                        {/* {selectedLanguage == 'eng' ? 'What did you like the most ?' : 'आपको सबसे ज्यादा क्या पसंद आया?'} */}
                                        {secondaryQuestion}
                                    </h5>
                                    <div className='checked-question'>
                                        <div className='col-12 mb-1 ms-3'>
                                            {metrics.map((metric, index) => (
                                                <Form.Check
                                                    label={metric.label}
                                                    value={metric.key}
                                                    // name="group1"
                                                    type='checkbox'
                                                    className='text-start mb-2'
                                                    id={index + 1}
                                                    onChange={handleCheckboxChange}
                                                    key={index}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='button-footer text-center'>
                            <div className='row justify-content-center'>
                                <div className='col-10 col-sm-6 col-md-4 col-lg-2 col-xl-2'>
                                    <Button variant='primary w-100' style={{ minHeight: '36px', borderRadius: '20px' }}>Next</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default LikeServices;
